export const modalRoute = (path, name, component, options = {}) => ({
  path,
  name,
  components: {
    modal: component,
  },
  ...options,
})
